import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'

export const error: CaseReducer<NinchatState> = (state) => state
